module.exports = __webpack_public_path__ + "static/media/悬浮球@2x.3b4a0b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/悬浮球@2x.png
// module id = 1388
// module chunks = 0